import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { post } from 'utils/rest'
import * as Toast from 'components/Toast'

export interface ResetPasswordState {
  hasResetPassword: boolean
  isLoading: boolean
  hasError: boolean
}

const createInitialStateResetPasswordState = (): ResetPasswordState => {
  return {
    hasResetPassword: false,
    isLoading: false,
    hasError: false,
  }
}

export const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState: createInitialStateResetPasswordState(),
  reducers: {
    resetingPassword: (state) => {
      state.isLoading = true
      state.hasResetPassword = false
      state.hasError = false
    },
    resetPasswordSuccess: (state) => {
      state.isLoading = false
      state.hasResetPassword = true
      state.hasError = false
    },
    resetPasswordFail: (state) => {
      state.isLoading = false
      state.hasResetPassword = false
      state.hasError = true
    },
  },
})

export interface ResetCredentials {
  newpassword: string
  confirmpassword: string
  resettoken: string
  userid: string
}

export const { resetingPassword, resetPasswordSuccess, resetPasswordFail } = resetPasswordSlice.actions

export const resetPasswordAsync =
  (newpassword: string, confirmpassword: string, resettoken: string, userid: string): AppThunk =>
  async (dispatch) => {
    dispatch(resetingPassword())
    try {
      const resetcredentials: ResetCredentials = {
        newpassword: newpassword,
        confirmpassword: confirmpassword,
        resettoken: resettoken,
        userid: userid,
      }
      const response = await post<boolean>('/api/authentication/resetpassword', resetcredentials)

      if (response.status === 200 && response.parsedBody?.data === true) {
        dispatch(resetPasswordSuccess())
      } else {
        Toast.dispatchToastError({ message: response.parsedBody?.message ?? 'Gick inte att �terst�lla l�senord' })
        dispatch(resetPasswordFail())
      }
    } catch (err) {
      dispatch(resetPasswordFail())
    }
  }

export const selectResetPasswordState = (state: RootState): ResetPasswordState => state.resetpassword

export default resetPasswordSlice.reducer
